import { PhonePreviewHeader } from './PhonePreviewHeader/PhonePreviewHeader'
import { PhonePreviewMessageComposer } from './PhonePreviewMessageComposer/PhonePreviewMessageComposer'
import { PhonePreviewRoot } from './PhonePreviewRoot/PhonePreviewRoot'

export const PhonePreview = {
  Root: PhonePreviewRoot,
  Header: PhonePreviewHeader,
  MessageComposer: PhonePreviewMessageComposer,
}
